/**
 * @file The files service
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { UploadService } from './upload.service';
import { AlertsService } from '../core/alerts.service';
/**
 * Class for the files service
 */
var FilesService = /** @class */ (function (_super) {
    tslib_1.__extends(FilesService, _super);
    /**
     * Constructs a FileService.
     * @param alertsService Service for giving user feedback
     */
    function FilesService(alertsService) {
        var _this = _super.call(this, alertsService) || this;
        /** The allowed mime types */
        _this.allowedMimeTypes = [
            'application/pdf',
            'application/msword',
            'application/excel',
            'text/plain',
            'application/vnd.ms-powerpoint',
            'application/zip',
            'image/png',
            'image/jpeg',
            'image/gif'
        ];
        /** The available files (only for demo!) */
        _this.uploads = [
            {
                id: 1,
                filename: 'Social-software-for-workforce management.pdf',
                url: '/Social-software-for-workforce management.pdf',
                type: 'application/pdf',
                size: 2300,
                user: 'Tom Verschoore de la Houssaije',
                created: new Date()
            },
            {
                id: 2,
                filename: 'Symagic-logo.png',
                url: '/Symagic-logo.png',
                type: 'application/pdf',
                size: 67300,
                user: 'Tom Verschoore de la Houssaije',
                created: new Date(Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 4))
            },
            {
                id: 3,
                filename: 'Word-document-about-social-in-planning.doc',
                url: '/Symagic-logo.png',
                type: 'application/pdf',
                size: 6087302,
                user: 'Tom Verschoore de la Houssaije',
                created: new Date(Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 4))
            },
            {
                id: 4,
                filename: 'Planning_Social.pdf',
                url: '/Planning_Social.pdf',
                type: 'application/pdf',
                size: 23300,
                user: 'Tom Verschoore de la Houssaije',
                created: new Date(Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 4))
            },
            {
                id: 5,
                filename: 'Planning automation.pdf',
                url: '/Planning automation.pdf',
                type: 'application/pdf',
                size: 167300,
                user: 'Tom Verschoore de la Houssaije',
                created: new Date(Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 7 * 3))
            },
            {
                id: 6,
                filename: 'Word-document-about-social-in-planning.doc',
                url: '/Word-document-about-social-in-planning.doc',
                type: 'application/pdf',
                size: 60302,
                user: 'Tom Verschoore de la Houssaije',
                created: new Date(Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 7 * 3))
            }
        ];
        return _this;
    }
    return FilesService;
}(UploadService));
export { FilesService };
